export class MealTiersMiniEntity {
  id?: number
  name?: string
  iconUrl?: string | null
}
